<div class="view-media-bar">
  
  <!-- Play / Pause -->
  <app-pin-button
    type="ghost"
    (click)="handlePlayClick()"
    matTooltipPosition="above"
    [matTooltip]="(animationPlaying$ | async) ? 'Pause' : 'Play'"
    [icon]="(animationPlaying$ | async) ? 'pause' : 'play'">
  </app-pin-button>

  <!-- Scrubber -->
  <app-view-scrubber
    *ngIf="showScrubber"
    style="width: 160px">
  </app-view-scrubber>

</div>